import { useProductCardImagesSizesContext } from 'product-card/hooks/useProductCardImagesSizesContext'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { generateImagesSizes } from 'utils/image/generateImagesSizes/generateImagesSizes'

export const useProductImageSizes = () => {
	const showAsFeatured = useShowAsFeatured()
	const { imagesSizes } = useProductCardImagesSizesContext()

	return generateImagesSizes(
		showAsFeatured ? imagesSizes.featured : imagesSizes.regular
	)
}
